import { PaginatorTemplate } from 'primereact/paginator/paginator';

export const paginatorTemplate: PaginatorTemplate =
  'FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown';
